import React, { createContext, useState, useCallback, useMemo } from 'react';
import { CheckCircle, AlertTriangle, Info, X } from '../../theme/icons.js';
import './Toast.css';

export const ToastContext = createContext({ show: () => {} });

let _id = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type = 'default', duration = 3000) => {
    const id = ++_id;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), duration);
  }, []);

  const toastValue = useMemo(() => ({ show }), [show]);

  return (
     <ToastContext.Provider value={toastValue}>
      {children}
      {/* role="status": Vorlesesoftware liest neue Meldungen vor, ohne die
          aktuelle Aufgabe zu unterbrechen. Ohne das Attribut kam von den
          Rückmeldungen („Gespeichert", „fehlgeschlagen") nichts an (Audit B9). */}
      <div className="toast-container" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`toast toast-${t.type}`}>
            <span className="toast-icon">
              {t.type === 'success' && <CheckCircle size={16} />}
              {t.type === 'error' && <AlertTriangle size={16} />}
              {t.type === 'warning' && <AlertTriangle size={16} />}
              {t.type === 'default' && <Info size={16} />}
            </span>
            <span className="toast-msg">{t.message}</span>
            <button
              aria-label="Meldung schließen"
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                color: 'inherit',
              }}
              onClick={() => setToasts((p) => p.filter((x) => x.id !== t.id))}
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
